import React, { useState, useEffect } from 'react';
import './ContactLycee.css';
import DashboardHeader from '../components/DashboardHeader';
import ParentNavigationBar from '../components/ParentNavigationBar';
import { MailIcon, ClockIcon } from '../components/Icons';
import { toSentenceCase } from '../utils/textUtils';

function ContactLycee() {
  const [formData, setFormData] = useState({
    nomParent: '',
    prenomParent: '',
    email: '',
    telephone: '',
    nomEnfant: '',
    classeEnfant: '',
    objet: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [userType, setUserType] = useState('student'); // Par défaut étudiant

  // Fonction pour déterminer la page de retour
  const getBackPage = () => {
    const currentPage = localStorage.getItem('currentPage');
    if (currentPage === 'parent-dashboard') {
      return 'parent-dashboard';
    }
    return 'student-dashboard'; // Par défaut
  };

  useEffect(() => {
    // Charger les informations du parent/élève depuis localStorage
    const userEmail = localStorage.getItem('user_email');
    const userType = localStorage.getItem('user_type'); // 'parent' ou 'student'
    if (userEmail) {
      fetchUserInfo(userEmail, userType);
    }
  }, []);

  const fetchUserInfo = async (email, userType) => {
    try {
      const response = await fetch(`http://127.0.0.1:8000/api/v1/etudiant/me?email=${email}`);
      const data = await response.json();
      
      if (response.ok && data.etudiant) {
        setFormData(prev => ({
          ...prev,
          email: data.etudiant.email,
          telephone: data.etudiant.telephone || '',
          nomEnfant: `${data.etudiant.nom} ${data.etudiant.prenom}`,
          classeEnfant: data.etudiant.classe || ''
        }));
      }
    } catch (error) {
      console.error('Erreur lors du chargement des informations:', error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      const response = await fetch('http://127.0.0.1:8000/api/v1/contact-lycee', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
        // Réinitialiser uniquement objet et message
        setFormData(prev => ({
          ...prev,
          objet: '',
          message: ''
        }));
        
        // Masquer le message de succès après 5 secondes
        setTimeout(() => setSuccess(false), 5000);
      } else {
        // Afficher l'erreur retournée par l'API
        const errorMessage = data.message || 'Erreur lors de l\'envoi du message. Veuillez réessayer.';
        setError(errorMessage);
        console.error('Erreur API:', data);
      }
    } catch (error) {
      console.error('Erreur:', error);
      setError('Erreur de connexion. Veuillez vérifier votre connexion internet et que le serveur backend est démarré.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <ParentNavigationBar 
        title={toSentenceCase("Contacter l'école")} 
        onBack={() => window.navigateTo && window.navigateTo(getBackPage())}
      />
      <div className="admin-container">
        <main className="parent-main admin-content-full">
          <div className="contact-lycee-content">
            <div className="contact-header">
              <h1 className="contact-title"><MailIcon size={24} /> {toSentenceCase("Écrire au Lycée")}</h1>
              <p className="contact-subtitle">
                {toSentenceCase("Contactez l'administration pour toute question ou demande concernant votre enfant")}
              </p>
            </div>

            {success && (
              <div className="alert alert-success">
                <span className="alert-icon">✅</span>
                <div className="alert-content">
                  <strong>Message envoyé avec succès!</strong>
                  <p>L'administration vous répondra dans les plus brefs délais.</p>
                </div>
              </div>
            )}

            {error && (
              <div className="alert alert-error">
                <span className="alert-icon">❌</span>
                <div className="alert-content">
                  <strong>Erreur</strong>
                  <p>{error}</p>
                </div>
              </div>
            )}

            <div className="contact-card">
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-section">
                  <h3 className="section-title">{toSentenceCase("Vos informations")}</h3>
                  
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">
                        {toSentenceCase("Nom du parent")} <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="nomParent"
                        className="form-input"
                        placeholder={toSentenceCase("Votre nom")}
                        value={formData.nomParent}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        {toSentenceCase("Prénom du parent")} <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="prenomParent"
                        className="form-input"
                        placeholder={toSentenceCase("Votre prénom")}
                        value={formData.prenomParent}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">
                        Email <span className="required">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        className="form-input"
                        placeholder="votre.email@exemple.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        {toSentenceCase("Téléphone")} <span className="required">*</span>
                      </label>
                      <input
                        type="tel"
                        name="telephone"
                        className="form-input"
                        placeholder="+229 XX XX XX XX"
                        value={formData.telephone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <h3 className="section-title">{toSentenceCase("Informations de l'enfant")}</h3>
                  
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">
                        {toSentenceCase("Nom et prénom de l'enfant")} <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="nomEnfant"
                        className="form-input"
                        placeholder={toSentenceCase("Nom complet de votre enfant")}
                        value={formData.nomEnfant}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        {toSentenceCase("Classe")} <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="classeEnfant"
                        className="form-input"
                        placeholder="Ex: 6ème, Terminale D"
                        value={formData.classeEnfant}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <h3 className="section-title">{toSentenceCase("Votre message")}</h3>
                  
                  <div className="form-group">
                    <label className="form-label">
                      {toSentenceCase("Objet")} <span className="required">*</span>
                    </label>
                    <select
                      name="objet"
                      className="form-select"
                      value={formData.objet}
                      onChange={handleChange}
                      required
                    >
                      <option value="">{toSentenceCase("Sélectionnez un objet")}</option>
                      <option value="Absence">{toSentenceCase("Absence")}</option>
                      <option value="Retard">{toSentenceCase("Retard")}</option>
                      <option value="Rendez-vous">{toSentenceCase("Demande de rendez-vous")}</option>
                      <option value="Résultats">{toSentenceCase("Question sur les résultats")}</option>
                      <option value="Comportement">{toSentenceCase("Comportement")}</option>
                      <option value="Santé">{toSentenceCase("Question de santé")}</option>
                      <option value="Paiement">{toSentenceCase("Question sur les paiements")}</option>
                      <option value="Orientation">{toSentenceCase("Orientation scolaire")}</option>
                      <option value="Autre">{toSentenceCase("Autre")}</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      {toSentenceCase("Message")} <span className="required">*</span>
                    </label>
                    <textarea
                      name="message"
                      className="form-textarea"
                      placeholder={toSentenceCase("Décrivez votre demande ou question en détail")}
                      rows="8"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                    <div className="char-count">
                      {formData.message.length} {toSentenceCase("caractères")}
                    </div>
                  </div>
                </div>

                <div className="form-actions">
                  <button 
                    type="submit" 
                    className="btn-submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner"></span>
                        {toSentenceCase("Envoi en cours")}...
                      </>
                    ) : (
                      <>
                        <span className="btn-icon">📤</span>
                        {toSentenceCase("Envoyer le message")}
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>

            <div className="contact-info-box">
              <h4>📞 {toSentenceCase("Autres moyens de contact")}</h4>
              <div className="contact-methods">
                <div className="contact-method">
                  <span className="method-icon"><MailIcon size={20} /></span>
                  <div className="method-details">
                    <strong>Email</strong>
                    <p><a href="mailto:contact@gsulespalmiers.bj" style={{ color: 'inherit', textDecoration: 'none' }}>contact@gsulespalmiers.bj</a></p>
                    <p><a href="mailto:info@gsulespalmiers.bj" style={{ color: 'inherit', textDecoration: 'none' }}>info@gsulespalmiers.bj</a></p>
                  </div>
                </div>
                <div className="contact-method">
                  <span className="method-icon">📱</span>
                  <div className="method-details">
                    <strong>{toSentenceCase("Téléphone")}</strong>
                    <p><a href="tel:+22997305230" style={{ color: 'inherit', textDecoration: 'none' }}>+229 97 30 52 30</a></p>
                  </div>
                </div>
                <div className="contact-method">
                  <span className="method-icon"><ClockIcon size={20} /></span>
                  <div className="method-details">
                    <strong>{toSentenceCase("Horaires")}</strong>
                    <p>Lun - Ven: 8h00 - 17h00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default ContactLycee;
